import { Accordion, AccordionTab } from 'primereact/accordion';
import { useTranslation } from 'react-i18next';

import { Advertiser } from '@features/users/adminPanel/components/Advertisers/components/Advertiser/Advertiser.tsx';
import { Header } from '@features/users/adminPanel/components/Advertisers/components/Header/Header.tsx';
import { AdvertisersCollection } from '@features/users/adminPanel/types/advertisers.types.ts';
import { EmptyState } from '@shared/components/EmptyState/EmptyState.tsx';
import { i18nNameSpace } from '@shared/consts/i18n.ts';
import { useAccordionAutoScroll } from '@shared/hooks/useAccordionAutoScroll';

interface AdvertisersProps {
  data: AdvertisersCollection;
}

export function Advertisers({ data }: AdvertisersProps) {
  const { t } = useTranslation(i18nNameSpace.USERS);

  const isAdvertisersCollectionEmpty = data.length === 0;
  const { handleTabOpen, handleTabClose, setAccordionRef } = useAccordionAutoScroll({
    scrollOffset: 30,
    enabled: true,
  });

  if (isAdvertisersCollectionEmpty) {
    return (
      <EmptyState
        title={t('page.adminPanel.advertisers.emptyState.header')}
        subtitle={t('page.adminPanel.advertisers.emptyState.body')}
      />
    );
  }

  return (
    <div ref={setAccordionRef}>
      <Accordion onTabOpen={handleTabOpen} onTabClose={handleTabClose}>
        {data.map((advertiser) => (
          <AccordionTab
            header={<Header status={advertiser.status} name={advertiser.name} vatNumber={advertiser.vatNumber} />}
            key={advertiser.id}
          >
            <Advertiser
              id={advertiser.id}
              name={advertiser.name}
              status={advertiser.status}
              vatNumber={advertiser.vatNumber}
              invoicingEmail={advertiser.invoicingEmail}
            />
          </AccordionTab>
        ))}
      </Accordion>
    </div>
  );
}
